// extracted by mini-css-extract-plugin
module.exports = {"root":"GPU-module--root--qK8He"};